export const DEFAULT_PROJECT_IMAGE =
    'https://firebasestorage.googleapis.com/v0/b/dev-as-cv.appspot.com/o/pc.jpg?alt=media&token=5796a242-8812-4467-b8a5-6f7e2082fc76';
